import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslations } from 'gatsby-plugin-translate'

import * as S from './styled'
import { SchedulingModal } from '../../../../SchedulingModal'
import { pushToDataLayerOnModalOpenning } from '../../../../../utils/tag'

const SchedulingButton = () => {
  const t = useTranslations()
  const translatedOnlineSchedule = t`Agendar`

  const [optionsVisible, setOptionsVisible] = useState(false)

  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)

  useEffect(() => {
    const handleContentToggle = event => {
      if (event.target.id !== 'schedulingOptions') {
        setOptionsVisible(false)
        return
      }
      setOptionsVisible(isVisible => !isVisible)
    }
    window.addEventListener('click', handleContentToggle)

    return () => {
      window.removeEventListener('click', handleContentToggle)
    }
  }, [])

  const handleClick = () => {
    setIsScheduleModalOpen(true)
    pushToDataLayerOnModalOpenning({ buttonLabel: 'Agendar Cabeçalho' })
  }

  return (
    <>
      <SchedulingModal
        isOpen={isScheduleModalOpen}
        onClose={() => setIsScheduleModalOpen(false)}
        origin="header"
      />
      <S.ScheduleButton visible={optionsVisible} id="schedulingOptions" onClick={handleClick}>
        {translatedOnlineSchedule}
      </S.ScheduleButton>
    </>
  )
}

SchedulingButton.propTypes = {
  schedulelLinkSp: PropTypes.string.isRequired,
  schedulelLinkRj: PropTypes.string.isRequired,
}

export default SchedulingButton
